<template>
	<div class="column">
		<Header></Header>
		<div class="colunm_main_box">
			<el-breadcrumb
				class="column_top_nav"
				separator-class="el-icon-arrow-right"
				style="font-size:14px;"
			>
				<span style="float:left;">当前位置：</span>
				<el-breadcrumb-item :to="{ path: '/' }"
					>首页</el-breadcrumb-item
				>
				<el-breadcrumb-item
					v-for="(item, index) in location"
					:key="index"
				>
					<span v-if="index != location.length - 1">{{ item }}</span>
					<span v-if="index == location.length - 1" class="active">{{
						item
					}}</span>
				</el-breadcrumb-item>
			</el-breadcrumb>
			<div class="column_center_box">
				<!-- 左侧导航 -->
				<div class="column_l_nav_box">
					<div class="column_l_nav_title">
						<span
							@click="enclumn_l_tab(0)"
							class="enclumn_l_tab active"
							>全国</span
						>
						<span @click="enclumn_l_tab(1)" class="enclumn_l_tab"
							>全球</span
						>
					</div>
					<div @click="columntoindex" class="colimn_l_top_select">
						全国能源数据概览
					</div>
					<div v-if="ifnav">
						<el-menu
							:default-active="currentChoose.toString()"
							:unique-opened="true"
							active-text-color="#4EAC41!important"
							class="el-menu-vertical-demo"
							@select="selectMenu"
							style="border-right:none;"
						>
							<div v-for="(item, index) in navData" :key="index">
								<el-submenu
									v-if="item.childrenList.length > 0"
									:index="item.id + ''"
									class="column_l_nav_item"
									:title="item.title_name"
								>
									<template slot="title">
										<span
											:style="
												currentChoose == item.id
													? 'color:rgb(78, 172, 65)'
													: ''
											"
											class="column_l_nav_style1"
											>{{ item.title_name }}</span
										>
									</template>
									<el-menu-item-group>
										<el-menu-item
											v-if="
												sitem.childrenList.length <= 0
											"
											v-for="(sitem,
											i) in item.childrenList"
											:key="i"
											:index="sitem.id + ''"
											:title="sitem.title_name"
											class="column_l_nav_style2"
											>.
											{{ sitem.title_name }}</el-menu-item
										>

										<el-submenu
											v-if="sitem.childrenList.length > 0"
											v-for="(sitem,
											i) in item.childrenList"
											:key="i"
											:index="sitem.id + ''"
											:title="sitem.title_name"
											class="column_l_nav_style2"
										>
											<template slot="title"
												><span
													class="column_l_nav_style1"
													>.
													{{ sitem.title_name }}</span
												></template
											>
											<el-menu-item
												v-for="(ssitem,
												j) in sitem.childrenList"
												:key="j"
												:title="ssitem.title_name"
												:index="ssitem.id + ''"
												class="column_l_nav_style2"
												>.
												{{
													ssitem.title_name
												}}</el-menu-item
											>
										</el-submenu>
									</el-menu-item-group>
								</el-submenu>
								<el-menu-item
									v-if="item.childrenList.length <= 0"
									:index="item.id + ''"
									:title="item.title_name"
									class="column_l_nav_item"
								>
									<span
										slot="title"
										class="column_l_nav_style1"
										>{{ item.title_name }}</span
									>
								</el-menu-item>
							</div>
							<!-- <el-menu-item index="2" class="column_l_nav_item">
                                <span slot="title" class="column_l_nav_style1">国内政策</span>
                            </el-menu-item>-->
						</el-menu>
					</div>
					<img
						class="column_l_nav_img"
						src="../../assets/main/navbg.png"
						alt=""
					/>
				</div>
				<!-- 右侧显示部分 -->
				<div class="column_r_box">
					<!-- 默认mode2 showType后台数据,4是全国能源概览，5是能源展示二级页--有俩柱状图，6是能源展示全国地图，8是只有表格，7是能源展示世界地图 -->
					<Mode4
						v-if="currentModel == '1-0'"
						:currentChoose="currentChoose"
					></Mode4>
					<Mode5
						v-if="currentModel == '1-3'"
						:currentChoose="currentChoose"
						:currentSource="currentSource"
					></Mode5>
					<Mode6
						v-if="currentModel == '1-2'"
						:currentChoose="currentChoose"
						:currentSource="currentSource"
					></Mode6>
          <Mode6Child
						v-if="currentModel == '1-6'"
						:currentChoose="currentChoose"
						:currentSource="currentSource"
            :currentModel="currentModel"
					></Mode6Child>
					<Mode8
						v-if="currentModel == '1-1'"
						:currentChoose="currentChoose"
						:currentSource="currentSource"
					></Mode8>
					<Mode9
						v-if="currentModel == '2-1' || currentModel == '2-2'"
						:currentChoose="currentChoose"
						:currentSource="currentSource"
					></Mode9>
					<Mode7
						v-if="currentModel == '1-4'"
						:currentChoose="currentChoose"
						:currentSource="currentSource"
					></Mode7>
          <Mode7Child
						v-if="currentModel == '1-7'"
						:currentChoose="currentChoose"
						:currentSource="currentSource"
            :currentModel="currentModel"
					></Mode7Child>
					<Mode10
						v-if="currentModel == '1-5'"
						:currentChoose="currentChoose"
						:currentSource="currentSource"
					></Mode10>
					<Mode11
						v-if="currentModel == '1-11'"
						:currentChoose="currentChoose"
						:currentSource="currentSource"
					></Mode11>
					<Mode12
						v-if="currentModel == '1-12'"
						:currentChoose="currentChoose"
						:currentSource="currentSource"
					></Mode12>
				</div>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>
<script>
import api from '@/../static/common/api/api.js';
import magic from '@/../static/common/magic.js';
import $ from 'jquery';

import Header from '@/components/header';
import Footer from '@/components/footer';
import Mode4 from '@/components/mode4'; //全国能源数据概览
import Mode5 from '@/components/mode5'; //能源展示二级页--有俩柱状图
import Mode6 from '@/components/mode6'; //能源展示全国各省
import Mode7 from '@/components/mode7'; //能源展示世界各省
import Mode6Child from '@/components/mode6Child'; //能源展示全国各省-子指标
import Mode7Child from '@/components/mode7Child'; //能源展示世界各省-子指标
import Mode8 from '@/components/mode8'; //能源展示--只有表格
import Mode9 from '@/components/mode9'; //能源展示--只有表格-无地区选择
import Mode10 from './mode10'; //能源展示--世界无地图
import Mode11 from './mode11'; //能源展示--全国平衡表
import Mode12 from './mode12'; //能源展示--地区平衡表
export default {
	props: {},
	components: {
		Header,
		Footer,
		Mode4,
		Mode5,
		Mode6,
		Mode7,
		Mode8,
		Mode9,
		Mode10,
		Mode11,
		Mode12,
		Mode6Child,
		Mode7Child,
	},
	data() {
		return {
			navData: [], //导航栏数据
			topTitle: '二级栏目', //左侧导航头部标题
			currentChoose: '', //当前选中的栏目uid
			currentModel: '1-0', //当前调用的模板 1-0：全国能源概览 1-1：表格模板(默认)
			currentSource: null, //当前选中的栏目source
			location: [], //获取位置数据
			ifword: 0, //判断当前是否是国内，国内：0，国外：1
			ifnav: true, //左侧nav是否显示
		};
	},
	computed: {},
	created() {
		let _name = magic.getUrlKey('name'); //获取url的参数name
		_name ? (this.topTitle = _name) : (this.topTitle = '二级栏目');

		let _uid = magic.getUrlKey('uid'); //获取url的参数uid
		_uid ? (this.currentChoose = _uid) : '';
	},
	mounted() {
		$('.column_l_nav_item .el-submenu__title').css({
			'font-size': '18px',
			color: '#8C8C8C',
		});

		let _id = magic.getUrlKey('id'); //获取url的参数id
		_id ? this.fetchNavList(_id) : (widnow.location.href = '/index.html');

		this.fetchLoaction(_id);
	},
	methods: {
		//点击全国能源数据概览跳转函数
		columntoindex() {
			this.currentModel = '1-0';
			this.currentChoose = 0;
			$('.colimn_l_top_select').css('color', 'rgb(78, 172, 65)');
		},
		//全国、全球tab切换
		enclumn_l_tab(num) {
			$('.enclumn_l_tab').removeClass('active');
			$('.enclumn_l_tab')
				.eq(num)
				.addClass('active');

			//点击世界数据时不显示全国能源数据概览
			if (num == 0) {
				$('.colimn_l_top_select').css('display', 'block');
			}
			if (num == 1) {
				$('.colimn_l_top_select').css('display', 'none');
			}

			this.ifword = num;
			let _id = magic.getUrlKey('id'); //获取url的参数id
			this.fetchNavList(_id);
		},
		//点击选择menu栏目
		selectMenu(id) {
			let _this = this;

			//console.log(id, 'id');
			for (let i = 0; i < _this.navData.length; i++) {
				// console.log(id);
				// console.log(_this.navData[i].id);
				if (_this.navData[i].id == id) {
					_this.currentModel = _this.navData[i].showType;
					_this.currentChoose = Number(id);
					_this.currentSource = _this.currentSource =
						_this.navData[i].source;
					//console.log(_this.currentModel, 'res111');
				} else {
					if (_this.navData[i].childrenList.length > 0) {
						for (
							let j = 0;
							j < _this.navData[i].childrenList.length;
							j++
						) {
							if (_this.navData[i].childrenList[j].id == id) {
								_this.currentModel =
									_this.navData[i].childrenList[j].showType;
								_this.currentChoose = Number(id);
								//console.log(_this.currentModel, 'res222');
								// console.log(_this.navData[i].childrenList[j]);
								_this.currentSource =
									_this.navData[i].childrenList[j].source;
							} else {
								if (
									_this.navData[i].childrenList[j]
										.childrenList.length > 0
								) {
									for (
										let k = 0;
										k <
										_this.navData[i].childrenList[j]
											.childrenList.length;
										k++
									) {
										if (
											_this.navData[i].childrenList[j]
												.childrenList[k].id == id
										) {
											_this.currentModel =
												_this.navData[i].childrenList[
													j
												].childrenList[k].showType;
											_this.currentChoose = Number(id);
											_this.currentSource =
												_this.navData[i].childrenList[
													j
												].childrenList[k].source;

											//console.log(
											//_this.currentModel,
											//'res333'
											//);
										}
									}
								}
							}
						}
					}
				}
			}

			$('.colimn_l_top_select').css('color', '#3F433F');
		},
		//获取导航数据
		fetchLoaction(_id) {
			let _this = this;

			api.getMenu(_id).then((res) => {
				_this.location = res.data.reverse();
			});
		},
		//获取导航数据
		fetchNavList(_id) {
			let _this = this;

			if (_id == 76) {
				//能源数据
				api.getNavList2(_this.ifword).then((res) => {
					logicInfo(res);
				});
			}
			if (_id == 77) {
				//碳交易
				api.getNavList3(_this.ifword).then((res) => {
					logicInfo(res);
				});
			}
			if (_id == 79) {
				//碳排放
				api.getNavList4(_this.ifword).then((res) => {
					logicInfo(res);
				});
			}

			let logicInfo = (res) => {
				this.ifnav = false;
				this.navData = res.data;

				if (res.data.length > 0) {
					let _uid = magic.getUrlKey('uid'); //获取url的参数uid

					//跳进来先展示概览页
					if (_uid == '1-0' && _this.ifword == 0) {
						_this.currentModel = '1-0';
						_this.currentChoose = '';
						$('.colimn_l_top_select').css(
							'color',
							'rgb(78, 172, 65)'
						);
					} else {
						// if(res.data[0].childrenList.length > 0){

						//     if(res.data[0].childrenList[0].childrenList.length > 0){

						//         _this.currentChoose = res.data[0].childrenList[0].childrenList[0].id + '';
						//         _this.currentModel = res.data[0].childrenList[0].childrenList[0].showType;
						//     }else{
						//         _this.currentChoose = res.data[0].childrenList[0].id + '';
						//         _this.currentModel = res.data[0].childrenList[0].showType;
						//     }
						//     //console.log(_this.currentChoose,'_this.currentChoose1');
						//     //console.log(_this.currentModel,'_this.currentModel1');
						// }else{
						//     _this.currentChoose = res.data[0].id;
						//     _this.currentModel = res.data[0].showType;
						//     //console.log(_this.currentModel,'_this.currentModel2')
						// }

						for (let i = 0; i < res.data.length; i++) {
							if (res.data[i].id == _uid) {
								_this.currentModel = res.data[i].showType;
								_this.currentChoose = _uid;
								//console.log(
								//_this.currentModel,
								//'_this.currentModel3'
								//);
							} else {
								if (res.data[i].childrenList.length > 0) {
									for (
										let j = 0;
										j < res.data[i].childrenList.length;
										j++
									) {
										if (
											res.data[i].childrenList[j].id ==
											_uid
										) {
											_this.currentModel =
												res.data[i].childrenList[
													j
												].showType;
											_this.currentChoose = _uid;
											//console.log(
											//_this.currentModel,
											//'_this.currentModel4'
											//);
										}
									}
								}
							}
						}
					}
					setTimeout(() => {
						_this.ifnav = true;
					}, 100);
				}
			};
		},
	},
};
</script>
<style scoped lang="less">
.column {
	width: 100%;
	/* height: 100vh; */
	background: #f2f2f2;
}
.colunm_main_box {
	width: 1300px;
	margin: 0 auto;
	min-height: 600px;
}
.column_top_nav {
	font-size: 12px;
	font-family: Source Han Sans CN;
	font-weight: 400;
	color: #1a1a1a;
	line-height: 26px;
	height: 54px;
	line-height: 54px;
}
.column_top_nav .active {
	color: #4eac41;
}
.column_center_box {
	width: 100%;
	overflow: hidden;
	margin-bottom: 50px;
}
// 左侧导航部分
.column_l_nav_box {
	float: left;
	width: 260px;
	// min-height: 460px;
	padding: 20px;
	background: #fff;
	border: 1px solid #e9e9e9;
	box-shadow: 0px 0px 6px 0px #eeeeee;
	position: relative;
	padding-bottom: 232px;
}
.column_l_nav_title {
	width: 260px;
	height: 46px;
	text-align: center;
	font-size: 18px;
	font-weight: 500;
	background: #edf7ec;
	border: 1px solid #328046;
	margin-bottom: 20px;
}
.column_l_nav_title span {
	display: inline-block;
	width: 130px;
	height: 46px;
	background: #edf7ec;
	// border: 1px solid #328046;
	text-align: center;
	line-height: 46px;
	float: left;
	cursor: pointer;
}
.column_l_nav_title span.active {
	background: #328046;
	color: #fff;
}
.column_l_nav_item {
	background: #f2f2f2;
	margin-bottom: 8px;
	font-size: 15px;
	font-family: Source Han Sans CN;
	font-weight: bold;
	color: #3f433f;
}
.column_l_nav_img {
	position: absolute;
	bottom: 0;
	left: 0;
	width: 100%;
}

.column_l_nav_style1 {
	font-size: 15px;
	font-family: Source Han Sans CN;
	font-weight: bold;
	// color: #3F433F;
}
.column_l_nav_style2 {
	border-bottom: 1px solid #f3f3f3;
	font-size: 16px;
	font-family: Source Han Sans CN;
	font-weight: 400;
	color: #8c8c8c;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
.column_l_nav_style3 {
	font-size: 13px;
	font-family: Source Han Sans CN;
	font-weight: 400;
	color: #808080;
}
.column_l_nav_style3:hover {
	color: #4eac41;
}
.colimn_l_top_select {
	width: 240px;
	height: 50px;
	background: #f2f2f2;
	border-radius: 1px;
	font-size: 15px;
	font-family: Source Han Sans CN;
	font-weight: bold;
	color: #3f433f;
	padding-left: 20px;
	line-height: 50px;
	margin-bottom: 20px;
	cursor: pointer;
}

// 右侧显示部分
.column_r_box {
	float: right;
	width: 950px;
	// padding:14px 30px;
	min-height: 578px;
	// background: #FFFFFF;
	border: 1px solid #e9e9e9;
	box-shadow: 0px 0px 6px 0px #eeeeee;
}
</style>



// WEBPACK FOOTER //
// src/view/encolumn/index.vue